import React from 'react';
import {AppField} from "../../ui/AppField";
import {useParams} from "react-router";
import {Box, IconButton} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {toast} from "react-toastify";
export function IntegrationAuthRedirectUrl() {
    const params:any = useParams();
    const redirectUrl = "https://connector.kpi.com/auth/oauth/return/" + params.id;
    return (
        <Box sx={{display: "flex", alignItems:"center"}}>
            <AppField
                fullWidth
                disabled
                name="url"
                labelText="Redirect URL"
                value={redirectUrl}
            />

            <IconButton onClick={() => {
                navigator.clipboard.writeText(redirectUrl).then(() => {
                    toast.success("Copied to clipboard",  {draggable: false})
                })
            }} sx={{mt:2}}>
                <ContentCopyIcon />
            </IconButton>
        </Box>
    );
}

